import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-infoscreen-header',
  imports: [CommonModule, MatProgressSpinnerModule, MatProgressBarModule],
  templateUrl: './infoscreen-header.component.html',
  styleUrl: './infoscreen-header.component.scss',
})
export class InfoscreenHeaderComponent {
  date = input.required<Date>();
  spinnerState = input<any>();
  progressValue = input<number>(0);
}
